import { FormField } from 'src/components/Form/types';

export const formFields: FormField[] = [
  {
    name: 'vendor',
    type: 'text',
    placeholder: 'ספק',
    validation: {
      required: 'שם ספק הינו שדה חובה',
      maxLength: { value: 100, message: 'אורך מקסימלי 100 תווים' },
    },
  },
  {
    name: 'source',
    type: 'select',
    placeholder: 'מקור',
    options: [{ value: 'manual', label: 'ידני' }],
    isDisabled: true,
    value: 'manual',
  },
  {
    name: 'amount',
    type: 'text',
    placeholder: 'סך קבלה',
    validation: {
      required: 'סך קבלה הינו שדה חובה',
      pattern: { value: /^[0-9]+(\.[0-9]{1,2})?$/, message: 'סך לא תקין' },
    },
  },
  {
    name: 'currency',
    type: 'select',
    placeholder: 'מטבע',
    validation: {
      required: 'מטבע הינו שדה חובה',
      valueAsNumber: true,
    },
  },
  {
    name: 'date',
    type: 'date',
    placeholder: 'תאריך הוצאה',
    validation: { required: 'תאריך הוצאה הינו שדה חובה' },
    value: new Date(),
  },
  {
    name: 'category',
    type: 'select',
    placeholder: 'קטגוריה',
    validation: { required: 'אנא בחר קטגוריה' },
    options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' },
    ],
  },
  {
    name: 'tags',
    type: 'chips',
    placeholder: 'תגיות',
  },
];
